import React from 'react';
import { Check } from 'lucide-react';
import { Section } from './Shared';
export const First30Days = () => {
  const weeks = [{
    title: 'Semana 1 — El Diagnóstico',
    desc: 'Por primera vez en años vas a saber exactamente cuánto entra, cuánto sale y por qué siempre falta aunque trabajes más. Identificás tus 3 contratos de pobreza principales y empezás a disolverlos.'
  }, {
    title: 'Semana 2 — La Limpieza',
    desc: 'Tu lenguaje sobre el dinero cambia. El estrés financiero empieza a bajar porque tenés protocolos para los momentos de crisis. Aplicás el EFT Financiero por primera vez y sentís el cambio en el cuerpo.'
  }, {
    title: 'Semana 3 — El Primer Mapa',
    desc: 'Tenés tu primer presupuesto consciente. Sabés cuál es tu Deuda #1 y cuándo la vas a liquidar si seguís el sistema. Empezás a notar las primeras sincronías: dinero que llega de donde no esperabas.'
  }, {
    title: 'Semana 4 — La Primera Victoria',
    desc: 'Cerrás el primer mes con algo que probablemente no tenías hace tiempo: un excedente. Aunque sea pequeño. Un peso ahorrado con consciencia. Una deuda que bajó. Una creencia que se disolvió. Una sincronía documentada. La evidencia de que el sistema funciona.'
  }];
  const checklist = ['Tu diagnóstico financiero completo', 'Tus contratos de pobreza identificados y en proceso de disolución', 'Tu primer presupuesto consciente activo', 'Tu Deuda #1 en la mira con fecha de salida', 'Tu primer fondo de emergencia iniciado', 'Tu Escudo Vibracional como hábito diario', 'Tu primera sincronía documentada', 'Tu frecuencia vibracional medida y creciendo', 'La certeza de que en Argentina sí se puede'];
  return <Section className="max-w-4xl" data-id="element-84">
      <div className="text-center mb-12" data-id="element-85">
        <h2 className="md:text-4xl font-serif font-bold mb-4 text-[24px] text-brand-gold" data-id="element-86">
          ⚡ LO QUE PASA EN TUS PRIMEROS 30 DÍAS
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16" data-id="element-87">
        {weeks.map((week, i) => <div key={i} className="glass-panel p-6 rounded-2xl border-brand-green/30 relative overflow-hidden" data-id="element-88">
            <div className="absolute top-0 left-0 w-1 h-full bg-brand-green" data-id="element-89"></div>
            <h3 className="font-serif font-bold text-lg mb-3 text-brand-text" data-id="element-90">
              {week.title}
            </h3>
            <p className="text-brand-text/80 text-sm leading-relaxed" data-id="element-91">
              {week.desc}
            </p>
          </div>)}
      </div>

      <div className="glass-panel p-8 md:p-10 rounded-3xl mb-12" data-id="element-92">
        <h3 className="text-xl font-serif font-bold mb-6 text-center text-brand-gold" data-id="element-93">
          AL DÍA 30 VAS A TENER:
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-94">
          {checklist.map((item, i) => <div key={i} className="flex items-start" data-id="element-95">
              <Check className="w-5 h-5 text-brand-green mr-3 mt-0.5 shrink-0" data-id="element-96" />
              <span className="text-brand-text/90 text-[14px]" data-id="element-97">{item}</span>
            </div>)}
        </div>
      </div>

      <div className="text-center" data-id="element-98">
        <p className="text-xl md:text-2xl font-serif italic text-brand-gold/90" data-id="element-99">
          "El día 30 no es el final. Es la primera vez que te creés que la
          transformación es real."
        </p>
        <p className="text-brand-text/60 mt-4 font-medium" data-id="element-100">✦ Lumen Akasha ✦</p>
      </div>
    </Section>;
};